<mat-toolbar class="p-0 mat-elevation-z1">
  <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">
    <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">
      <button mat-icon-button class="navbar-toggle-button" *ngIf="!hiddenNavbar && !rightNavbar"
        (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
        <mat-icon class="secondary-text">menu</mat-icon>
      </button>

      <div class="toolbar-separator" *ngIf="!hiddenNavbar && !rightNavbar" fxHide.gt-md></div>

      <div fxLayout="row" fxLayoutAlign="start center" *ngIf="horizontalNavbar">
        <div class="logo ml-16"><img class="logo-icon" src="assets/images/cashme-logo.png" /></div>
      </div>

      <div class="px-8 px-md-16" fxLayout="row" fxLayoutAlign="start stretch">
        <ng-container *ngIf="showShortcuts()">
          <app-custom-shortcuts></app-custom-shortcuts>
        </ng-container>

        <!-- BOTTONE ONBOARDING - MOSTRA SOLO SE canDoOnboarding è true (SELLER) -->
        <button *ngIf="canDoOnboarding && !isBuyer" mat-raised-button class="onboarding-toolbar-btn" fxHide fxShow.gt-xs
          (click)="hasOnboardingAccount ? resumeOnboarding() : startOnboarding()" [ngClass]="{
            'start-onboarding-btn': !hasOnboardingAccount,
            'resume-onboarding-btn': hasOnboardingAccount
          }">
          <mat-icon style="margin-right: 5px">
            {{ hasOnboardingAccount ? 'refresh' : 'launch' }}
          </mat-icon>
          <span>{{ (hasOnboardingAccount ? 'RESUME_ONBOARDING' : 'START_ONBOARDING') | translate }}</span>
        </button>
        <!-- BOTTONE ONBOARDING BUYER -->
        <button *ngIf="isBuyer && canDoBuyerOnboarding" mat-raised-button class="onboarding-toolbar-btn" fxHide
          fxShow.gt-xs (click)="hasBuyerOnboardingAccount ? resumeBuyerOnboarding() : startBuyerOnboarding()" [ngClass]="{
            'start-onboarding-btn': !hasBuyerOnboardingAccount,
            'resume-onboarding-btn': hasBuyerOnboardingAccount
          }">
          <mat-icon style="margin-right: 5px">
            {{ hasBuyerOnboardingAccount ? 'refresh' : 'launch' }}
          </mat-icon>
          <span>{{ (hasBuyerOnboardingAccount ? 'RESUME_ONBOARDING' : 'START_ONBOARDING') | translate }}</span>
        </button>
      </div>
    </div>

    <div class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">
      <div class="toolbar-separator"></div>

      <!-- Languages menu (rimuovo il duplicato) -->
      <button mat-button fxHide fxShow.gt-xs class="language-button" [matMenuTriggerFor]="languageMenu">
        <div fxLayout="row" fxLayoutAlign="center center">
          <img class="flag mr-8" style="max-height: 15px;"
            [src]="'/assets/icons/flags/' + selectedLanguage.flag + '.svg'" />
          <span class="iso text-uppercase">{{ selectedLanguage.id }}</span>
        </div>
      </button>

      <mat-menu #languageMenu="matMenu" [overlapTrigger]="false">
        <button mat-menu-item *ngFor="let lang of languages" (click)="setLanguage(lang)">
          <span fxLayout="row" fxLayoutAlign="start center">
            <img class="flag mr-16" style="max-height: 15px;" [src]="'/assets/icons/flags/' + lang.flag + '.svg'" />
            <span class="iso">{{ lang.title }}</span>
          </span>
        </button>
      </mat-menu>
      <!-- /end Languages menu -->

      <div class="toolbar-separator" fxHide fxShow.gt-xs></div>

      <!-- User menu -->
      <button mat-button [matMenuTriggerFor]="userMenu" class="user-button">
        <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
          <div fxLayout="column" fxLayoutGap="5px">
            <span fxHide fxShow.gt-sm> {{ mainService.user?.businessName }} </span>
            <span fxHide fxShow.gt-sm style="font-size: 12px; color: #999999;">
              {{ mainService.user?.firstName }} {{ mainService.user?.lastName }}
            </span>
          </div>
          <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
        </div>
      </button>

      <mat-menu #userMenu="matMenu" [overlapTrigger]="false">
        <button mat-menu-item class="" (click)="logout()">
          <mat-icon>exit_to_app</mat-icon>
          <span>{{ 'TOOLBAR.USER.EXIT' | translate }}</span>
        </button>
      </mat-menu>
      <!-- /end User menu -->

      <div class="toolbar-separator" fxHide fxShow.gt-xs></div>

      <!--      <button mat-icon-button-->
      <!--              class="quick-panel-toggle-button"-->
      <!--              (click)="toggleSidebarOpen('quickPanel')"-->
      <!--              aria-label="Toggle quick panel">-->
      <!--        <mat-icon class="secondary-text">format_list_bulleted</mat-icon>-->
      <!--      </button>-->

      <div class="toolbar-separator" *ngIf="!hiddenNavbar && rightNavbar" fxHide fxShow.gt-xs></div>

      <button mat-icon-button class="navbar-toggle-button" *ngIf="!hiddenNavbar && rightNavbar"
        (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
        <mat-icon class="secondary-text">menu</mat-icon>
      </button>
    </div>
  </div>
</mat-toolbar>